import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchMovies = async () => {
    const res = await axios.get(`${API_BASE_URL}/movie/now-showing`);
    return res.data?.data ?? { nowShowing: [], comingSoon: [] };
};

export const useMovies = () => {
    const { data, isLoading } = useQuery({
        queryKey: ["movies"],
        queryFn: fetchMovies,
        staleTime: Infinity,
    });

    return {
        nowShowing: data?.nowShowing ?? [],
        comingSoon: data?.comingSoon ?? [],
        isMoviesLoading: isLoading,
    };
};
